<div class="container">
  <!--externalJobReference: string;-->
  <!--externalPropertyReference: string;-->
  <!--minimumAttendance: number;-->
  <!--planningWindowEnd: Date;-->
  <!--planningWindowStart: Date;-->
  <!--status: JobStatus;-->
  <h1>{{ 'scheduler.general.create' | translate }} {{ 'scheduler.jobs.title' | translate }}</h1>
  <form (ngSubmit)="onCreateJob()" [formGroup]="jobForm">

    <div class="row">
      <mat-form-field class="col-6">
        <input formControlName="externalJobReference" matInput placeholder="External Job Reference">
      </mat-form-field>
    </div>

    <div class="row">
      <mat-form-field class="col-6">
        <input formControlName="externalPropertyReference" matInput placeholder="External Property Reference">
      </mat-form-field>
    </div>


    <mat-toolbar>

      <button [disabled]="!jobForm.valid" color="primary" mat-raised-button type="submit">Submit</button>
    </mat-toolbar>

  </form>
</div>
